import { EComponentTypes } from "../../../Utils/Enums";
import { UserModel } from "../../../Utils/Models";
import { formatDate, isString } from "../../../Utils/Utils";
import { Vocabulary } from "../../../Utils/Vocabulary";

/**
 * Generates an array of column objects for the user actions report.
 */
export const userActionsColumns = [
  {
    name: "createdAt",
    label: Vocabulary.createdAt,
    options: {
      customBodyRender: (value: any) => {
        return formatDate(value, "dd.MM.yyyy HH:mm");
      },
      exportValue: (value: any) => value ? formatDate(value, "dd.MM.yyyy HH:mm") : "",
    },
  },
  {
    name: "userName",
    label: Vocabulary.user,
  },
  {
    name: "orderNumber",
    label: Vocabulary.order,
  },
  {
    name: "message",
    label: Vocabulary.action,
    options: {
      customBodyRender: (value: any) => {
        return isString(value) ? value : JSON.stringify(value);
      },
      exportValue: (value: any) => isString(value) ? value : JSON.stringify(value),
    },
  },
];

/**
 * Generates an array of filter objects for the user actions report.
 *
 * @param {UserModel[]} users - The list of users to use for the autocomplete filter.
 *
 * @returns {Array<Filter>} An array of filter objects.
 */
export const userActionsFilters = (users: UserModel[]) => [
  {
    property: "userId",
    autocompleteFilterProperty: "_id",
    label: Vocabulary.user,
    type: EComponentTypes.AUTOCOMPLETE,
    validation: null,
    defaultValue: users[0]?._id,
    options: users,
    otherOptions: { disableClearable: true },
  },
];
